module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1158-min.948924bd.jpg";